// Order of categories should match the order of the overlays in the overlays folder

const Category = Object.freeze({
    HATS: "hats",
    UPPER: "upper",
    LOWER: "lower",
    SHOES: "shoes",
})

export default Category;